import Axios from 'axios'

export default {
  verificarAcesso: () => Axios.get('/esocial/verificar-acesso'),
  contratarEmpresas: empresas => {
    return Axios.post('/esocial/empresas/contratar', empresas)
  },
  empresasESocial: params => Axios.get('/esocial/empresas', { params }),
  empresasDisponiveis: params => Axios.get('/esocial/empresas/disponiveis', { params }),
  enviarEventos: ({ ids, tipoAmbiente, idEmpresa }) => {
    return Axios.post('/esocial/eventos/enviar', {
      ids,
      tipoAmbiente,
      idEmpresa,
    })
  },
  excluirEventos: ({ ids, idEmpresa }) => {
    return Axios.post('/esocial/eventos/excluir', { ids, idEmpresa })
  },
  inativarEventos: ({ ids, idEmpresa }) => {
    return Axios.put('/esocial/eventos/inativar', { ids, idEmpresa })
  },
  consultarEventos: protocoloEnvio => Axios.post('/esocial/eventos/consultar', { protocoloEnvio }),
  getCertificadoStatus: idEmpresa => Axios.get(`/esocial/empresas/${idEmpresa}/certificado-status`),
  listarEventos: idEmpresa => Axios.get(`/esocial/eventos/empresas/${idEmpresa}`),
  extrairRelatorio: ids => {
    return Axios.post('/esocial/eventos/extrair-relatorio', { ids }, { responseType: 'blob' })
  },
  downloadEventos: ({ ids, tipoAmbiente, assinado }) => {
    return Axios.post('/esocial/eventos/download', { ids, tipoAmbiente, assinado }, { responseType: 'blob' })
  },
  getEventoRectification: id => Axios.get(`/esocial/eventos/retificar/${id}`),
  retificarEvento: evento => {
    return Axios.post('/esocial/eventos/retificar', { evento })
  },
}
